import { useQuery } from "@tanstack/react-query";
import { api } from "../../../../singleton/axios";

export interface ReportQuota {
  used: number;
  limit: number;
  remaining: number;
  resetDate: string;
  resetInMs: number;
  /** Prepaid credit affordability for extra reports beyond the free quota. */
  credits: {
    balanceCredits: number;
    reportPriceCredits: number;
    extraReportsAvailable: number;
    canTopUp: boolean;
  };
}

/**
 * Hook to fetch the user's weekly stock analysis report quota
 * Quota resets every Sunday at midnight UTC
 */
export const useReportQuota = () => {
  return useQuery<ReportQuota, Error>({
    queryKey: ["stockAnalysisReportQuota"],
    queryFn: async () => {
      const response = await api.get<ReportQuota>(
        "/stock-analysis-reports/quota"
      );
      return response.data;
    },
    staleTime: 60 * 1000, // 1 minute - quota changes infrequently
    gcTime: 5 * 60 * 1000, // Keep in cache for 5 minutes
    refetchOnWindowFocus: true, // Refresh when user returns to tab
  });
};
